import { render, staticRenderFns } from "./contacts.vue?vue&type=template&id=2ba3819e&scoped=true&"
import script from "./contacts.vue?vue&type=script&lang=js&"
export * from "./contacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba3819e",
  null
  
)

export default component.exports